import { render, staticRenderFns } from "./StickyNotification.vue?vue&type=template&id=57c80402&scoped=true"
import script from "./StickyNotification.vue?vue&type=script&lang=ts"
export * from "./StickyNotification.vue?vue&type=script&lang=ts"
import style0 from "./StickyNotification.vue?vue&type=style&index=0&id=57c80402&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57c80402",
  null
  
)

export default component.exports